import React from 'react';

import { ArrowDown, ArrowUp, Arrows } from '../icons';
import { Column } from './data-table';

interface DataTableSortableColumnProps<T> extends React.HTMLAttributes<HTMLDivElement> {
  column: Column<T>;
  label: string;
}

export const DataTableSortableColumn = <T,>({
  column,
  label,
  ...props
}: DataTableSortableColumnProps<T>) => {
  const sortDirection = column.getIsSorted();
  const iconClassName = 'ml-2 h-3 w-4';

  return (
    <div
      className="flex items-center cursor-pointer"
      onClick={() => column.toggleSorting()}
      {...props}
    >
      <span className="truncate">{label}</span>
      {sortDirection === 'asc' ? (
        <ArrowUp className={iconClassName} />
      ) : sortDirection === 'desc' ? (
        <ArrowDown className={iconClassName} />
      ) : (
        <Arrows className={iconClassName} />
      )}
    </div>
  );
};
